import { EQUIPMENTS_PATH } from 'cpmCarparks/navigation';

module.exports = {
  path: EQUIPMENTS_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/Equipments'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/routes/show/routes/equipments/index.js